export const MIN_SUBSCRIBED_POWER = 1
export const MAX_SUBSCRIBED_POWER = 36
